import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import { isStoreSeller } from '@/features/currentUser/selectors';
import queryDuck from '@/features/purchaseHistoryPage/ducks/query';
import withQuerySync from '@/hocs/withQuerySync';

import {
  getPurchaseIds,
  getPurchasesError,
  getPurchasesTotalCount,
  isLoadingPurchases,
} from '../selectors';
import PurchaseHistory from './component';
import styles from './styles';

const mapStateToProps = state => ({
  error: getPurchasesError(state),
  purchaseIds: getPurchaseIds(state),
  isLoading: isLoadingPurchases(state),
  totalCount: getPurchasesTotalCount(state),
  isStoreSeller: isStoreSeller(state),
});

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
  withStyles(styles),
)(PurchaseHistory);
